/**
 * @component return-nav
 * @css return-nav.css
 * @primitives .btn.btn-secondary
 */
import { escapeHtml } from '../utils/html-utils.js';
import { isSafeReturnPath, readReturnPath, returnPathLabel } from '../utils/return-to-url.js';

class ReturnNav extends HTMLElement {
  connectedCallback() {
    this.render();
    this.attachListeners();
  }

  getReturnPath() {
    const attr = this.getAttribute('return-to');
    if (attr && isSafeReturnPath(attr)) {
      return attr;
    }
    return readReturnPath();
  }

  render() {
    const returnTo = this.getReturnPath();
    if (!returnTo) {
      this.innerHTML = '';
      return;
    }

    const label = this.getAttribute('label') || returnPathLabel(returnTo);
    this.innerHTML = `
      <a href="${escapeHtml(returnTo)}" class="btn btn-secondary return-nav-btn" data-return-to="${escapeHtml(returnTo)}">
        ← Back to ${escapeHtml(label)}
      </a>
    `;
  }

  attachListeners() {
    const link = this.querySelector('[data-return-to]');
    link?.addEventListener('click', (e) => {
      e.preventDefault();
      const path = link.dataset.returnTo;
      if (path && window.router) {
        window.router.navigate(path);
      }
    });
  }
}

customElements.define('return-nav', ReturnNav);
